/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';

export function renderHelp() {
    return (<a href="https://radwegplanung-muenchen.de/doc/build/html/index.html" target="_blank">Dokumentation Radwegplanung München</a>
    );
}
